module.exports = __webpack_public_path__ + "img/37ne.02dc6e42.svg";